export default "__VITE_ASSET__DwUKwrKl__"